import PrimaryButton from '@components/_atoms/Button/PrimaryButton';
import TextInput from '@components/_atoms/TextInput';
import Typography from '@components/_atoms/Typography';
import SummaryTextList from '@components/_templates/career/SummaryTextList';
import { TypoVariant } from '@constants/atoms';
import styled from '@emotion/styled';
import { gray } from '@styles/Colors';

const FaqTopContentWrapper = styled.div`
  width: 100%;
  max-width: 1080px;
  display: flex;
  gap: 40px;
  flex-direction: column;
  margin: 0 auto;
`;

const FaqSearchWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 36px;
`;

const FaqSearchInputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  align-self: stretch;
`;

type Props = {
  categoryList: string[];
  categoryIndex: number;
  handleSearchText: (searchText: string) => void;
  handleCategoryIndex: (categoryIndex: number) => void;
};

export default function FaqTopContent({ categoryList, categoryIndex, handleSearchText, handleCategoryIndex }: Props) {
  return (
    <>
      <FaqTopContentWrapper>
        <Typography variant={TypoVariant.H6} style={{ width: '100%', textAlign: 'center' }}>
          FAQ
        </Typography>
        <FaqSearchWrapper>
          <Typography variant={TypoVariant.H6}>
            안녕하세요, <br />
            무엇을 도와드릴까요?
          </Typography>
          <FaqSearchInputWrapper>
            <TextInput
              style={{ width: '100%' }}
              placeholder="검색어를 입력하세요."
              onChange={(event) => {
                handleSearchText(event.target.value);
              }}
            />
            <PrimaryButton>검색</PrimaryButton>
          </FaqSearchInputWrapper>
          <SummaryTextList
            summaryList={categoryList}
            defaultColor={gray.gray6}
            activeIndex={categoryIndex}
            onClick={(index) => handleCategoryIndex(index)}
          />
        </FaqSearchWrapper>
      </FaqTopContentWrapper>
    </>
  );
}
